var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { ref: "header", staticClass: "yqg-header" }, [
    _c("div", { staticClass: "buffer" }),
    _vm._v(" "),
    _vm._m(0),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "container-wrappper" }, [
      _c("div", { staticClass: "container" }, [
        _c("img", {
          staticClass: "logo",
          attrs: { src: require("./img/logo-white.png") },
        }),
        _vm._v(" "),
        _c("img", {
          staticClass: "active-logo",
          attrs: { src: require("./img/logo.png") },
        }),
        _vm._v(" "),
        _c("span", [
          _c("i", { staticClass: "star" }),
          _vm._v("\n                资信等级 AAA 企业\n                "),
          _c("i", { staticClass: "star" }),
        ]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }